<template>
    <transition name="fade">
      <div v-if="active" class="loading-overlay">
        <div class="loader-wrapper">
          
          <div class="loader-dots">
            <div></div>
            <div></div>
            <div></div>
          </div>
          
          <p v-if="message" class="loading-text">{{ message }}</p>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: "Loader",
    props: {
      active: {
        type: Boolean,
        required: true
      },
      message: {
        type: String,
        default: "অপেক্ষা করুন..."
      }
    }
  };
  </script>
  
  <style scoped>
  /* 1. The Overlay Backdrop */
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9); /* High opacity white background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Blocks clicks on everything behind it */
    backdrop-filter: blur(2px); /* Optional: Slight blur of the page behind */
  }
  
  .loader-wrapper {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .loading-text {
    margin-top: 5px; /* Less margin needed for this specific animation */
    color: #6c757d;
    font-weight: 600;
    font-size: 0.95rem;
    letter-spacing: 0.5px;
  }
  
  /* 2. The Dot Wave CSS Animation */
  .loader-dots {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .loader-dots div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 16px;
    background: #90288b; /* Your Brand Blue */
    animation: loader-dots 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    border-radius: 50%;
  }
  .loader-dots div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
  }
  .loader-dots div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
  }
  .loader-dots div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
  }
  
  @keyframes loader-dots {
    0% {
      top: 8px;
      height: 64px;
    }
    50%, 100% {
      top: 24px;
      height: 32px;
    }
  }
  
  /* 3. Vue Transition Effects */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  </style>